import CommunicationConst from "./communication-const";
import CommunicationHelpers from "./helpers";
import CommunicationFields from "./fields";
import CommunicationForms from "./forms";

const Communication = {
  Const: CommunicationConst,
  Helpers: CommunicationHelpers,
  Fields: CommunicationFields,
  Forms: CommunicationForms,
};

export default Communication;
